import { Injectable } from '@angular/core'
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http'
import { EMPTY, Observable, switchMap } from 'rxjs'
import { environment } from '../../../environments/environment'
import { Store } from '@ngrx/store'
import { selectIsSharedCase } from '../../state/case/case.selectors'

@Injectable()
export class SharedInterceptor implements HttpInterceptor {
    constructor(private readonly store: Store) {}

    intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        return this.store.select(selectIsSharedCase).pipe(
            switchMap(isShared => {
                if (isShared) {
                    if (request.method.toLowerCase() !== 'get') return EMPTY
                    const urlRewritten = SHARED_URL_REWRITE(request.url)
                    if (urlRewritten !== request.url) {
                        return next.handle(request.clone({ url: urlRewritten }))
                    }
                }
                return next.handle(request)
            })
        )
    }
}

const SHARED_URL_REWRITE = (url: string): string => {
    const prefixOld = `${environment.apiUrl}/datasets`
    const prefixNew = `${environment.publicApiUrl}/datasets`
    return url.replace(prefixOld, prefixNew)
}
